export const FULL_MONTH_TRANSLATION_KEYS = [
  "common.months.january",
  "common.months.february",
  "common.months.march",
  "common.months.april",
  "common.months.may",
  "common.months.june",
  "common.months.july",
  "common.months.august",
  "common.months.september",
  "common.months.october",
  "common.months.november",
  "common.months.december",
];

export const getFullMonthLabel = (monthIndex, translate) => {
  const key =
    FULL_MONTH_TRANSLATION_KEYS[monthIndex] ||
    FULL_MONTH_TRANSLATION_KEYS[0];

  return translate(key);
};